import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { IMAGES, NAV_TYPE, BMW_TYPE } from "@/lib/site";

const SERVICES = [
  {
    img: IMAGES.bmw,
    tag: "BMW DIAGNOSTIC",
    tagClass: "text-blue-400 border-blue-500/40 bg-blue-500/10",
    title: "BMW Factory Diagnostic Search",
    text: "Full ISTA+ interrogation of every control module. Coding, adaptations and software updates handled in-house.",
    service: BMW_TYPE,
  },
  {
    img: IMAGES.nav,
    tag: "JAPAN TO NZ",
    tagClass: "text-emerald-400 border-emerald-500/40 bg-emerald-500/10",
    title: "BMW Navigation Map Conversion",
    text: "Japanese-import iDrive converted to New Zealand maps, English language and NZ radio bands. FSC codes and full navigation restored.",
    service: NAV_TYPE,
  },
  {
    img: IMAGES.engine,
    tag: "SERVICING",
    tagClass: "text-amber-500 border-amber-600/40 bg-amber-600/10",
    title: "Servicing & Performance",
    text: "Interim to full scheduled servicing, brake and suspension overhauls, and measured performance upgrades.",
    service: "Scheduled Servicing",
  },
];

export const Services = ({ onBook }) => {
  return (
    <section id="services" className="bg-[#0D1017] py-24 lg:py-32" data-testid="services-section">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <div className="flex flex-wrap items-end justify-between gap-6">
          <div>
            <motion.p
              initial={{ opacity: 0, y: 12 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              className="font-mono text-xs uppercase tracking-[0.3em] text-amber-500"
            >
              What we do
            </motion.p>
            <motion.h2
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ delay: 0.1 }}
              className="mt-4 font-display text-4xl uppercase leading-[0.95] tracking-tight text-slate-50 sm:text-5xl lg:text-6xl"
            >
              Under the spotlight
            </motion.h2>
          </div>
          <p className="max-w-sm text-sm leading-relaxed text-slate-400">
            Three doors into the workshop. Pick one — the booking form will be pre-filled for you.
          </p>
        </div>

        <div className="mt-16 grid grid-cols-1 gap-8 md:grid-cols-3 lg:gap-10">
          {SERVICES.map((s, i) => (
            <motion.article
              key={s.title}
              initial={{ opacity: 0, y: 32 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ delay: i * 0.14, duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
              className="group"
              data-testid={`service-card-${i}`}
            >
              <div className="clipped-frame relative aspect-[4/5] overflow-hidden border border-white/10">
                <img
                  src={s.img}
                  alt={s.title}
                  className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/10 to-transparent" />
                <span className={`absolute left-4 top-4 border px-3 py-1 font-mono text-[10px] uppercase tracking-[0.2em] ${s.tagClass}`}>
                  {s.tag}
                </span>
                <div className="absolute inset-x-0 bottom-0 p-6">
                  <h3 className="text-xl font-bold text-slate-50 sm:text-2xl">{s.title}</h3>
                </div>
              </div>
              <p className="mt-5 text-sm leading-relaxed text-slate-400">{s.text}</p>
              <button
                onClick={() => onBook(s.service)}
                data-testid={`service-book-btn-${i}`}
                className="mt-4 flex items-center gap-2 font-mono text-xs uppercase tracking-[0.2em] text-amber-500 transition-colors duration-200 hover:text-amber-400"
              >
                Book this service
                <ArrowUpRight size={14} className="transition-transform duration-200 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
              </button>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
};
